// reach_ui/src/components/VastGPT/index.js
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogContent,
} from '@material-ui/core'
import { toggleDialog } from '../../actions/view'
import AiKnowledge from './AiKnowledge'
import { selectChat } from './redux'

export default withRouter(
  connect(
    state => ({
      dialogOpen: state.view.dialogs?.AiKnowledge?.open,
    }),
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
          selectChat,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {
          borderRadius: 0,
          overflowY: 'auto',
        },
        dialogContentRoot: {
          position: 'relative',
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
      }))(
        ({
          dialogOpen,
          classes,
          toggleDialog,
          selectChat,
        }) => {
          return (
            <Dialog
              fullWidth
              maxWidth="xl"
              fullScreen
              open={Boolean(dialogOpen)}
              onClose={() => {
                selectChat(null)
                toggleDialog({
                  open: false,
                  dialog: 'AiKnowledge',
                })
              }}
              aria-labelledby="responsive-dialog-title"
              PaperProps={{ classes: { rounded: classes.rounded } }}
            >
              <DialogContent 
                classes={{ root: classes.dialogContentRoot }}
                style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
              >
                {dialogOpen ? <AiKnowledge /> : null}
              </DialogContent>
            </Dialog>
          )
        },
      ),
    ),
  ),
)
